// @flow
import * as React from 'react';
import { Select } from 'components';
import { type AsyncValueType, AsyncValues } from 'lib/async-value';

type IndicatorIconProps = {
  published: ?AsyncValueType<boolean>,
};

function IndicatorIcon({ published }: IndicatorIconProps) {
  let color = '#ccc';
  if (published === true) {
    color = '#8AC734';
  } else if (published === false) {
    color = 'rgba(240, 94, 36, 1)';
  }

  return (
    <svg
      viewBox="0 0 200 200"
      xmlns="http://www.w3.org/2000/svg"
      className="w1 h1"
      style={{
        marginRight: '0.3rem',
        color,
      }}
    >
      <circle cx="100" cy="100" r="100" fill="currentColor" />
    </svg>
  );
}

const SITE_STATUS_OPTIONS = [
  { label: 'Published', value: true },
  { label: 'Unpublished', value: false },
];
const EMPTY_SITE_STATUS_SELECT_OPTIONS = [];

type SiteStatusSelectProps = {
  published: ?AsyncValueType<boolean>,
  onChange: Function,
};

export default class SiteStatusSelect extends React.Component<SiteStatusSelectProps> {
  render() {
    const { published, onChange } = this.props;

    let value = published;
    let options = EMPTY_SITE_STATUS_SELECT_OPTIONS;
    let placeholder;
    let disabled;

    if (published === AsyncValues.Pending) {
      placeholder = 'Updating site status...';
      value = null;
      disabled = true;
    } else if (published instanceof Error) {
      placeholder = 'Failed to update site status';
      value = null;
      disabled = true;
    } else if (published == null) {
      placeholder = 'Site status unavailable';
      value = null;
      disabled = true;
    } else {
      options = SITE_STATUS_OPTIONS.map(option => {
        return option.value === published
          ? { ...option, disabled: true }
          : option;
      });
    }

    return (
      <React.Fragment>
        <div className="flex items-center mb1">
          <IndicatorIcon published={published} />
          <h3 className="dark-gray ma0 brandon">
            Site Status{published === AsyncValues.Pending && '*'}
          </h3>
        </div>
        <Select
          value={value}
          options={options}
          placeholder={placeholder}
          disabled={disabled}
          name="ugc-site-status"
          clearable={false}
          // $FlowIssue
          onChange={(v: { value: boolean }) => onChange(v.value)}
        />
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/client/UgcSiteStatus.js